import React from "react";
import {
  Paper,
  Typography,
  Divider,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";

const ViewTestKit = ({ testKit }) => {
  if (!testKit) {
    return null;
  }

  const formatCost = (value) =>
    value !== null && value !== undefined ? `$${Number(value).toFixed(2)}` : "";

  return (
    <Paper elevation={2} sx={{ p: 2, mt: 2 }}>
      <Typography variant="subtitle2" sx={{ mb: 1 }}>
        Test Kit Overview
      </Typography>
      <Divider sx={{ mb: 1.5 }} />

      <Grid container spacing={1.5}>
        <Grid item xs={12} sm={4} md={2}>
          <Typography variant="body2">Kit: {testKit.kitName}</Typography>
        </Grid>
        <Grid item xs={12} sm={4} md={2}>
          <Typography variant="body2">SKU: {testKit.sku}</Typography>
        </Grid>
        <Grid item xs={12} sm={4} md={2}>
          <Typography variant="body2">
            Can Build: <strong>{testKit.canBuild}</strong>
          </Typography>
        </Grid>
        <Grid item xs={12} sm={4} md={2}>
          <Typography variant="body2">
            Total Cost: {formatCost(testKit.totalCost)}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={4} md={2}>
          <Typography variant="body2">
            Active: {testKit.isActive ? "Yes" : "No"}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={8} md={6}>
          <Typography variant="body2">
            Limited By: {testKit.limitingComponents}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={8} md={6}>
          <Typography variant="body2">
            Description: {testKit.description}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={8} md={6}>
          <Typography variant="body2">Notes: {testKit.notes}</Typography>
        </Grid>
      </Grid>

      <Divider sx={{ my: 1.5 }} />
      <Typography variant="subtitle2" sx={{ mb: 1 }}>
        Components
      </Typography>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>Product</TableCell>
            <TableCell>Variant</TableCell>
            <TableCell>SKU</TableCell>
            <TableCell>Qty per Kit</TableCell>
            <TableCell>In Stock</TableCell>
            <TableCell>Can Build</TableCell>
            <TableCell>Unit Cost</TableCell>
            <TableCell>Line Cost</TableCell>
            <TableCell>Notes</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {(testKit.items || []).map((item) => (
            <TableRow
              key={item.id}
              // The component(s) capping the build count stand out.
              sx={item.isLimiting ? { backgroundColor: "#fff3e0" } : undefined}
            >
              <TableCell>{item.productName}</TableCell>
              <TableCell>{item.variantName}</TableCell>
              <TableCell>{item.sku}</TableCell>
              <TableCell>{item.quantity}</TableCell>
              <TableCell>{item.stockOnHand}</TableCell>
              <TableCell>
                {item.isLimiting ? <strong>{item.canBuild}</strong> : item.canBuild}
              </TableCell>
              <TableCell>{formatCost(item.unitCost)}</TableCell>
              <TableCell>{formatCost(item.lineCost)}</TableCell>
              <TableCell>{item.notes}</TableCell>
            </TableRow>
          ))}
          {(testKit.items || []).length === 0 && (
            <TableRow>
              <TableCell colSpan={9}>
                <Typography variant="body2" color="textSecondary">
                  No components
                </Typography>
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </Paper>
  );
};

export default ViewTestKit;
